import { render, staticRenderFns } from "./MatchedAd.vue?vue&type=template&id=4165165f&scoped=true&"
import script from "./MatchedAd.vue?vue&type=script&lang=js&"
export * from "./MatchedAd.vue?vue&type=script&lang=js&"
import style0 from "./MatchedAd.vue?vue&type=style&index=0&id=4165165f&lang=scss&scoped=true&"
import style1 from "./MatchedAd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4165165f",
  null
  
)

export default component.exports